"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalWidth = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_modal_1 = __importDefault(require("react-modal"));
var __1 = require("..");
var ModalCloseButton_1 = __importDefault(require("./ModalCloseButton"));
var react_1 = require("@emotion/react");
var ModalWidth;
(function (ModalWidth) {
    ModalWidth["fixed"] = "fixed";
    ModalWidth["full"] = "full";
})(ModalWidth = exports.ModalWidth || (exports.ModalWidth = {}));
var getCSSRules = function (props, _a, style, innerContentStyle) {
    var _b, _c, _d, _e;
    var colors = _a.colors, borderRadius = _a.borderRadius, margins = _a.margins, breakpoints = _a.breakpoints;
    if (style === void 0) { style = {}; }
    if (innerContentStyle === void 0) { innerContentStyle = {}; }
    return ({
        content: __assign((_b = { background: colors.Grey[0], borderRadius: borderRadius.sm, bottom: 'auto', boxShadow: "0px 1px 8px rgba(0, 0, 0, 0.1)", boxSizing: 'border-box', color: colors.Grey[1000], display: 'flex', flexDirection: 'column', left: '50%', marginRight: '-50%', maxHeight: '95vh', outline: 'none', position: 'absolute', right: 'auto', top: '50%', transform: 'translate(-50%, -50%)', width: '95%', zIndex: props.zIndex ? props.zIndex + 1 : 10001 }, _b["@media (max-width:".concat(breakpoints.sm, "px)")] = {
            maxWidth: '100vw',
            maxHeight: '100%',
            height: '100%',
            width: '100vw',
            borderRadius: 0,
        }, _b), style),
        innerContent: __assign((_c = { boxSizing: 'border-box', height: '100%', overflowY: 'auto', padding: margins.sm, width: '100%' }, _c["@media (max-width:".concat(breakpoints.sm, "px)")] = {
            padding: margins.md,
        }, _c), innerContentStyle),
        bottomBorder: {
            width: '100%',
            height: 4,
        },
        fullscreen: {
            borderRadius: 0,
            bottom: 0,
            left: 0,
            marginRight: 0,
            maxHeight: '100%',
            right: 0,
            top: 0,
            transform: 'none',
            width: 'auto',
        },
        slideup: {
            '&&': (_d = {
                    borderTopLeftRadius: borderRadius.xl,
                    borderTopRightRadius: borderRadius.xl,
                    bottom: 0,
                    height: 'auto',
                    left: 'auto',
                    maxHeight: '80vh',
                    position: 'fixed',
                    top: 'auto',
                    transform: 'none',
                    width: '100vw'
                },
                _d["@media (min-width:".concat(breakpoints.sm, "px)")] = {
                    borderRadius: borderRadius.sm,
                    bottom: 'auto',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '500px',
                },
                _d),
        },
        action: {
            '&&': (_e = {},
                _e["@media (max-width:".concat(breakpoints.sm, "px)")] = {
                    maxWidth: 'calc(100vw - 30px)',
                    maxHeight: '90vh',
                    height: 'auto',
                    borderRadius: 4,
                },
                _e),
        },
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, .5)',
            zIndex: props.zIndex ? props.zIndex : 10000,
        },
    });
};
var Modal = function (props) {
    var theme = (0, react_1.useTheme)();
    var canClose = props.canClose, children = props.children, className = props.className, fullScreen = props.fullScreen, gradientStrokePercentage = props.gradientStrokePercentage, hideCloseButton = props.hideCloseButton, innerContentStyle = props.innerContentStyle, isOpen = props.isOpen, onClose = props.onClose, shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick, style = props.style, styles = props.styles, variant = props.variant, width = props.width;
    var classes = getCSSRules(props, theme, __assign(__assign({ width: width === ModalWidth.fixed ? '500px' : '100vw' }, styles), style), innerContentStyle);
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
            var _b;
            var css = _a.css, cx = _a.cx;
            return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, __assign({ appElement: typeof document === 'object'
                    ? document.getElementById('root')
                    : undefined, onRequestClose: canClose ? onClose : undefined, overlayClassName: css(classes.overlay), css: css(classes.content), className: cx(className, (_b = {},
                    _b[css(classes.fullscreen)] = fullScreen || variant === 'fullScreen',
                    _b[css(classes.slideup)] = variant === 'slideUp',
                    _b[css(classes.action)] = variant === 'action',
                    _b)), isOpen: isOpen, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ css: css(classes.innerContent) }, { children: [canClose && !hideCloseButton && ((0, jsx_runtime_1.jsx)(ModalCloseButton_1.default, { fullScreen: fullScreen, onClose: onClose }, void 0)), children] }), void 0), !props.shouldHideGradientStroke && ((0, jsx_runtime_1.jsx)("div", __assign({ css: css(classes.bottomBorder) }, { children: (0, jsx_runtime_1.jsx)(__1.GradientStroke, { percentage: gradientStrokePercentage &&
                                Math.min(gradientStrokePercentage, 100) }, void 0) }), void 0))] }), void 0));
        } }, void 0));
};
Modal.defaultProps = {
    canClose: true,
    isOpen: false,
    variant: 'regular',
    width: ModalWidth.fixed,
};
exports.default = Modal;
//# sourceMappingURL=index.js.map